// app/(routes)/ai-workflows/layout.tsx
'use client';

import { usePathname } from 'next/navigation';
import React from 'react';

import { SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";

interface AiWorkflowsLayoutProps {
  children: React.ReactNode;
}

export default function AiWorkflowsLayout({ children }: AiWorkflowsLayoutProps) {
  const pathname = usePathname();

  // Conditionally hide header and footer for the creation flow
  const isCreateFlow = pathname.includes('/ai-workflows/create');

  if (isCreateFlow) {
    // For the creation page, we want a full-screen experience without the standard header/footer
    return (
      <div className="flex flex-col h-screen bg-surface-light">
        {/* You could have a minimal header specific to the creation flow here if needed */}
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    );
  }

  // Default layout for all other pages under /ai-workflows
  return (
    <div className="bg-surface-light min-h-screen">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
} 